module.exports = __webpack_public_path__ + "static/media/体检平台.8a4bb73.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mov/体检平台.mp4
// module id = 4Ke0
// module chunks = 1